import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { StarRatingComponent } from './star-rating.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatIconModule,
    StarRatingComponent
  ],
  exports: [
    StarRatingComponent
  ]
})
export class StarRatingModule { }
